module.exports = __webpack_public_path__ + "static/media/ico_tint_clear.a16a8944.svg";